import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
  { title: 'Responses', isLink: true, href: '/responses' },
  { title: 'Activity Log', isLink: false },
];

const Title: PageTitle = {
  title: 'Response',
  prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
};

export { Breadcrumbs, Title };
